import * as actions from './tailoringSize/actions'
import * as mutations from './tailoringSize/mutations'
import * as getters from './tailoringSize/getters'

import { dataProps } from './tailoringSize/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringSize.js